import(/* webpackMode: "eager" */ "/tmp/build_b6f0e66e/src/app/feed/layout.tsx");
